var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.1667H6.00004C2.38004 15.1667 0.833374 13.62 0.833374 10V6.00004C0.833374 2.38004 2.38004 0.833374 6.00004 0.833374H10C13.62 0.833374 15.1667 2.38004 15.1667 6.00004V10C15.1667 13.62 13.62 15.1667 10 15.1667ZM6.00004 1.83337C2.92671 1.83337 1.83337 2.92671 1.83337 6.00004V10C1.83337 13.0734 2.92671 14.1667 6.00004 14.1667H10C13.0734 14.1667 14.1667 13.0734 14.1667 10V6.00004C14.1667 2.92671 13.0734 1.83337 10 1.83337H6.00004Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 10.1733C7.87325 10.1733 7.74659 10.1266 7.64659 10.0266L5.64659 8.02659C5.45325 7.83326 5.45325 7.51326 5.64659 7.31993C5.83992 7.12659 6.15992 7.12659 6.35325 7.31993L7.99992 8.96659L9.64659 7.31993C9.83992 7.12659 10.1599 7.12659 10.3533 7.31993C10.5466 7.51326 10.5466 7.83326 10.3533 8.02659L8.35325 10.0266C8.25325 10.1266 8.12659 10.1733 7.99992 10.1733Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.1733C7.72667 10.1733 7.5 9.94663 7.5 9.6733V4.33997C7.5 4.06663 7.72667 3.83997 8 3.83997C8.27333 3.83997 8.5 4.06663 8.5 4.33997V9.6733C8.5 9.9533 8.27333 10.1733 8 10.1733Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 12.1534C6.5933 12.1534 5.17996 11.9267 3.83996 11.48C3.57996 11.3934 3.43996 11.1067 3.52663 10.8467C3.6133 10.5867 3.89329 10.44 4.15996 10.5334C6.63996 11.36 9.36663 11.36 11.8466 10.5334C12.1066 10.4467 12.3933 10.5867 12.48 10.8467C12.5666 11.1067 12.4266 11.3934 12.1666 11.48C10.82 11.9334 9.40663 12.1534 7.99996 12.1534Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4e7f6f5dbb299ecb3a90079f4337a2bf.svg";
export { ForwardRef as ReactComponent };